// extracted by mini-css-extract-plugin
module.exports = {"itemGroup":"header-tnc_itemGroup__Ebs3h","cardStyle":"header-tnc_cardStyle__OYbDj","title":"header-tnc_title__5CDLp","description":"header-tnc_description__2Gm4R"};